<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>出价记录</span>
      </div>
      <div>
        <el-card shadow="hover" class="cart-item" v-for="(item,index) in list" v-bind:key="index">
          <div class="cart-item-body">
            <div class="goods-item">
              <div class="goods-main">
                <div class="goods-img">
                  <img :src="item.photo" alt="">
                </div>
                <div class="goods-msg">
                  <div class="name">{{item.product_name}}</div>
                  <div class="extra">
                    <p class="countdown">{{time[index] | formatTimer}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="amount">
              <p class="">最高出价：<span class="span">￥{{item.maxPrice}}</span></p>
              <p class="">我的出价：<span class="span">￥{{item.myPrice}}</span></p>
              <div class="bidstatus" :class="classes[index]"></div>
            </div>
            <div class="operate">
              <el-button type="primary" plain>
                <router-link class="link" :to="{path:'/auction/item',query:{id:item.id}}">查看作品</router-link>
              </el-button>
            </div>
          </div>
        </el-card>
        <el-link class="btn-more" :underline="false" disabled v-if="isend">没有更多了</el-link>
        <el-link class="btn-more" :underline="false" @click="myOfferPrice" v-if="!isend">加载更多</el-link>
      </div>
    </el-card>
  </div>
</template>
<script>
import {
  Usercenter
} from "../../model/usercenter.js";
let usercenter = new Usercenter();
export default {
  name: 'history',
  data() {
    return {
      list: [],
      pageIndex: 1,
      pageSize: 6,
      time: [],
      isend: false,
      timer: '',
      classes: []
    }
  },
  components: {

  },
  filters: {
    formatTimer(time) {
      function normalize(x) {
        return x < 10 ? '0' + x : x;
      }
      if (time > 0) {
        var h = normalize(time / 3600 | 0);
        var m = normalize(time / 60 % 60 | 0);
        var s = normalize(time % 60);
        return '距结束' + (h + ':' + m + ':' + s);
      } else {
        return '已结束';
      }
    }
  },
  methods: {
    myOfferPrice() {
      let _this = this;
      usercenter.myOfferPrice({
        CustomerId: _this.user ? _this.user.id : "",
        PageIndex: _this.pageIndex,
        PageSize: _this.pageSize
      }).then((res) => {
        console.log(res)
        _this.nowtime = res.data.NowTime;
        let plist = res.data.data;
        if (plist.length < _this.pageSize || plist.length == 0) {
          _this.isend = true;
        }
        _this.list = plist.length > 0 ? _this.list.concat(plist) : _this.list;
        _this.priceStatus(_this.list)//判断作品状态
        _this.pageIndex++;
        let ret = [];
        let moment = require("moment");
        let nowtime = moment(_this.nowtime, 'YYYY-MM-DD HH:mm:ss').format('X');
        plist.forEach(function (item) {
          var overTime = moment(item.end_date, 'YYYY-MM-DD HH:mm:ss').format('X');
          var fromTime = overTime - nowtime;
          ret.push(fromTime);
        });
        _this.time.push.apply(_this.time, ret);
        _this.setTimeout();
      })
    },
    setTimeout() {
      var _this = this;
      // let timer
      _this.timer && clearInterval(_this.timer);
      _this.timer = setInterval(function () {
        let list = _this.time;
        let ret = [];
        list.forEach(function (item) {
          item > 0 ? item-- : '结束';
          ret.push(item);
        });
        _this.time = ret;
      }, 1000);
    },
    priceStatus(list) {
      let _this = this;
      let moment = require("moment");
      let nowtime = moment(_this.nowtime, 'YYYY-MM-DD HH:mm:ss').format('X');
      _this.classes = [];
      list.forEach((element) => {
        var overTime = moment(element.end_date, 'YYYY-MM-DD HH:mm:ss').format('X');
        var fromTime = overTime - nowtime;
        if (fromTime > 0) {
          if (parseInt(element.myPrice, 10) >= parseInt(element.maxPrice, 10)) {
            _this.classes.push('ontop')
          } else {
            _this.classes.push('backward')
          }
        } else {
          if (parseInt(element.myPrice, 10) >= parseInt(element.maxPrice, 10)) {
            _this.classes.push('done')
          } else {
            _this.classes.push('beout')
          }
        }
      });
    }
  },
  created() {
    this.myOfferPrice()
  },
  destroyed() {
    clearInterval(this.timer);
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/card.scss";
.link {
  color: #cfa972;
}
.link:hover {
  color: #fff;
}
.countdown {
  color: #d1131f;
  font-size: 14px;
}
.el-button--primary.is-plain:hover .link {
  color: #fff;
}
</style>